module.exports = __webpack_public_path__ + "img/8b2ece40b271addb7c600b9b7e8bf80b.png";